import { UploadUrl } from "../base-url.js";

//#region ../base/upload/methods/fetch.ts
var UploadFetch = class extends UploadUrl {};

//#endregion
export { UploadFetch };